export class Parametri {
  nome: string;
  valStr: string;
  valNum: number;
  valBool: boolean;
  visibile?: boolean;
}